import { Navigate, Outlet, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./staff.css";
import { StaffAuthProvider, RequireStaff, RequireSuper } from "./StaffAuth";
import StaffLayout from "./StaffLayout";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import Overview from "./pages/Overview";
import Team from "./pages/Team";
import Users from "./pages/Users";
import Reports from "./pages/Reports";
import Tickets from "./pages/Tickets";
import Partnerships from "./pages/Partnerships";
import Venues from "./pages/Venues";

const Shell = () => (
  <StaffAuthProvider>
    <Outlet />
    <Toaster theme="dark" position="top-right" />
  </StaffAuthProvider>
);

export const staffRoutes = (
  <Route path="/staff" element={<Shell />}>
    <Route path="login" element={<Login />} />
    <Route path="reset-password" element={<ResetPassword />} />
    <Route element={<RequireStaff><StaffLayout /></RequireStaff>}>
      <Route index element={<Navigate to="overview" replace />} />
      <Route path="overview" element={<Overview />} />
      <Route path="users" element={<Users />} />
      <Route path="reports" element={<Reports />} />
      <Route path="tickets" element={<Tickets />} />
      <Route path="partnerships" element={<Partnerships />} />
      <Route path="venues" element={<Venues />} />
      <Route path="team" element={<RequireSuper><Team /></RequireSuper>} />
      <Route path="*" element={<Navigate to="/staff/overview" replace />} />
    </Route>
  </Route>
);
